import {createSlice} from "@reduxjs/toolkit";

const initialSensorMonitorState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  SensorMonitorForEdit: undefined,
  lastError: null,
  filter:null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const SensorMonitorSlice = createSlice({
  name: "SensorMonitor",
  initialState: initialSensorMonitorState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSensorMonitorById
    SensorMonitoringVariableFetched: (state, action) => {
      state.actionsLoading = false;
      state.SensorMonitorForEdit = action.payload.SensorMonitorForEdit;
      state.error = null;
    },
    
    // findMonitors
    SensorMonitorsFetched: (state, action) => {
    
      const { count, data,filter } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = data;
      state.totalCount = count;
      filter ? (state.filter = filter): (state.filter = null)
     
    },
    // createMonitor
    SensorMonitoringVariableCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.data);
      // state.entities.push(action.payload.SensorMonitor);
    },
    
     // updateMonitor
     SensorMonitoringVariableUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.SensorMonitoringVariable.id) {
          return action.payload.SensorMonitoringVariable;
        }
        return entity;
      });
    },
    // deleteMonitoring
    SensorMonitoringVariableDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    
  
  }
});
